import { CheckboxContainer, CheckmarkIcon, FilterItem, FilterLabel } from 'components/FilterRow'
import { Category, CategoryKey } from 'constants/tokenLists/categories'
import styled from 'styled-components'

const RowWrapper = styled.div`
  display: flex;
  gap: 0.5rem;
  justify-content: space-between;
  width: 100%;

  @media (max-width: 768px) {
    overflow-x: auto;
    flex-wrap: nowrap;
    min-width: 0;
  }
`

const CategoryItem = styled(FilterItem)`
  flex: 1 0 auto;
  justify-content: space-between;
  padding: 6px 10px;
  background: transparent;
  border-radius: 6px;

  @media (max-width: 900px) {
    padding: 6px;
  }
`

const CategoryLabel = styled(FilterLabel)`
  @media (max-width: 900px) {
    margin-right: 8px;
  }
`

const CategoryCheckboxContainer = styled(CheckboxContainer)`
  width: 16px;
  height: 16px;
  border: 1px solid ${({ theme }) => theme.buttonBorder};
`

export default function CategoryView({
  categories,
  selected,
  onSelect,
}: {
  categories: Category[]
  selected: CategoryKey[]
  onSelect: (name: CategoryKey) => void
}) {
  const isActive = (category: Category) => {
    return selected.includes(category.name)
  }
  return (
    <RowWrapper>
      {categories.map((category) => (
        <CategoryItem key={category.name} onClick={() => onSelect(category.name)} $isActive={isActive(category)}>
          <CategoryLabel>{category.name}</CategoryLabel>
          <CategoryCheckboxContainer>{isActive(category) && <CheckmarkIcon size={10} />}</CategoryCheckboxContainer>
        </CategoryItem>
      ))}
    </RowWrapper>
  )
}
